export default "__VITE_ASSET__B64ad5p7__"